function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9a4 4 0 004 4v1.78a1.1 1.1 0 001.824.828L8.804 13H12a4 4 0 004-4V4a4 4 0 00-4-4H4a4 4 0 00-4 4v5zm5-5h6a1 1 0 110 2H5a1 1 0 010-2zm0 3h3a1 1 0 010 2H5a1 1 0 010-2z",
  fill: "#243143"
});

function SvgChat16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDlDMCAxMS4yMDkxIDEuNzkwODYgMTMgNCAxM1YxNC43Nzk2QzQgMTUuMDQ2MSA0LjA5NjcxIDE1LjMwMzUgNC4yNzIxNyAxNS41MDRDNC42NzIyMiAxNS45NjEyIDUuMzY3MTYgMTYuMDA3NSA1LjgyNDM2IDE1LjYwNzVMOC44MDQzMSAxM0gxMkMxNC4yMDkxIDEzIDE2IDExLjIwOTEgMTYgOVY0QzE2IDEuNzkwODYgMTQuMjA5MSAwIDEyIDBINEMxLjc5MDg2IDAgMCAxLjc5MDg2IDAgNFY5Wk01IDRIMTFDMTEuNTUyMyA0IDEyIDQuNDQ3NzIgMTIgNUMxMiA1LjU1MjI4IDExLjU1MjMgNiAxMSA2SDVDNC40NDc3MiA2IDQgNS41NTIyOCA0IDVDNCA0LjQ0NzcyIDQuNDQ3NzIgNCA1IDRaTTUgN0g4QzguNTUyMjggNyA5IDcuNDQ3NzIgOSA4QzkgOC41NTIyOCA4LjU1MjI4IDkgOCA5SDVDNC40NDc3MiA5IDQgOC41NTIyOCA0IDhDNCA3LjQ0NzcyIDQuNDQ3NzIgNyA1IDdaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPgo=";
export { SvgChat16 as ReactComponent };